<template lang="pug">
  div.payment
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    :hideAddButton="true"
    :hideSearch="true"
    :toolbarTitle="toolbarTitle"
    )

    e-table(
    :defaultColumnWidth="150"
    :items="items"
    :showCheckbox="false"
    :showDeleteButton="false"
    :showEditButton="false"
    idKeyName="number"
    )
</template>

<script>
  import {payment} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import permissionMixin from '../../mixins/permission-mixin.js'

  export default {
    mixins: [tableMixin, permissionMixin],
    title () {
      return this.toolbarTitle
    },
    computed: {
      toolbarTitle () {
        return `Ошибки в пачке ${this.$route.params.packetId}`
      }
    },
    methods: {
      getEndpoint (route) {
        return payment.invoiceError(route.params.packetId, route)
      }
    }
  }
</script>
